import SearchBarLocationPicker from './SearchBarLocationPicker';

export default SearchBarLocationPicker;
